import {Component, Input, OnInit} from '@angular/core';
import {Studium} from '../model/studium';
import {AppService} from '../app.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-studium-item',
  templateUrl: './studium-item.component.html',
  styleUrls: ['./studium-item.component.css']
})
export class StudiumItemComponent implements OnInit {

  @Input()
  data: Studium;
  show = true;
  red = false;
  title: string;

  constructor(private appService: AppService, private router: Router) { }

  ngOnInit() {
    this.red = this.appService.getRed();

    this.title = this.getTitle(this.data);
  }

  getTitle(s: Studium) {
    if (s === null || s.zapisneListy === null || s.zapisneListy.length === 0 || s.zapisneListy[0] === null) {
      return s.studijnyProgram.skratka + ' - ' + s.studijnyProgram.popis;
    }
    return s.zapisneListy[0].rocnik + s.studijnyProgram.skratka + s.kruzok
      + ' - ' + s.studijnyProgram.popis + ' (' + s.zapisneListy[0].akademickyRok + ')';
  }

  headerClick() {
    this.show = !this.show;
  }

  goToDetail() {
    this.appService.setStudium(this.data);
    this.router.navigate(['studium']);
  }
}
